import { useTranslation } from 'react-i18next';
import { ApiError } from '../api/errors';
import { useErrorMessage } from '../i18n/use-error-message';
import { Button } from './Button';
import { Notice } from './Notice';

/** Failed request: the translated cause, the error code (reportable) and an optional retry. */
export function ErrorState({ error, onRetry }: { error: unknown; onRetry?: () => void }) {
  const { t } = useTranslation();
  const message = useErrorMessage();
  const code = error instanceof ApiError ? error.code : 'CLIENT_ERROR';
  return (
    <Notice tone="fail">
      <div className="fs-error-state">
        <strong>{t('common.errorTitle')}</strong>
        <span>{message(error)}</span>
        <span>
          {t('errors.codeLabel')} <code dir="ltr">{code}</code>
        </span>
        {onRetry && (
          <span>
            <Button variant="secondary" size="sm" onClick={onRetry}>
              {t('common.retry')}
            </Button>
          </span>
        )}
      </div>
    </Notice>
  );
}
